export const sourceLevels = [
  {
    id: 'sd',
    label: '标清',
    res: '480P / 576P',
    bitrate: '约 0.6 – 1.2 Mbps',
    container: 'MP4（H.264）',
    suitable: '手机流量环境、老旧设备',
    note: '体积小、加载快，适合移动网络下快速浏览。画面细节有限，在大屏上观感较普通，但胜在流畅不卡顿。',
  },
  {
    id: 'hd',
    label: '高清',
    res: '720P',
    bitrate: '约 1.5 – 3 Mbps',
    container: 'MP4（H.264）',
    suitable: '普通家庭宽带、笔记本与平板',
    note: '清晰度与体积之间较均衡的档位，是日常观剧最常用的选择。兼顾加载速度与画面表现，适合大多数网络条件。',
  },
  {
    id: 'fhd',
    label: '超清',
    res: '1080P',
    bitrate: '约 4 – 8 Mbps',
    container: 'MP4 / MKV（H.264 / H.265）',
    suitable: '光纤宽带、大屏电视与显示器',
    note: '画面细节与层次明显更好，适合在电视或显示器上观看。对网络和存储空间有一定要求，建议带宽稳定时选择。',
  },
  {
    id: 'uhd',
    label: '4K 超高清',
    res: '2160P',
    bitrate: '约 15 – 40 Mbps',
    container: 'MKV（H.265 / AV1）',
    suitable: '千兆网络、支持 4K 的显示设备',
    note: '画质最完整的档位，适合追求细节与色彩表现的观看场景。体积较大，需要较快的网络与充足的存储空间。',
  },
];